export * from "./theme";
export * from "./box-shadow";
import themeColors from "./colors";
export { themeColors };
export * from "./hex-to-rgb";

import theme from "./theme";
export const onpreoTheme = theme;
